import { css } from 'emotion';

export const title = css(`
	max-width: 100%;
`);
